var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { PanelBarItem } from './PanelBarItem';
/**
 * @hidden
 */

export var renderChildren = function renderChildren(animation, state, handleSelect, children, parentExpanded, root, parentPrivateKey) {
  if (animation === void 0) {
    animation = true;
  }

  if (parentExpanded === void 0) {
    parentExpanded = true;
  }

  if (root === void 0) {
    root = true;
  }

  if (parentPrivateKey === void 0) {
    parentPrivateKey = [];
  }

  return React.Children.map(children, function (child, idx) {
    if (child && child.type === PanelBarItem) {
      var nestedChildren = void 0;
      var privateKey = parentPrivateKey.length ? parentPrivateKey[parentPrivateKey.length - 1] + ("." + idx) : "." + idx;

      if (child.props.children) {
        nestedChildren = renderChildren(animation, state, handleSelect, child.props.children, (state.expanded || []).indexOf(privateKey) > -1 && parentExpanded, false, parentPrivateKey.concat([privateKey]));
      }

      return React.cloneElement(child, __assign({}, child.props, {
        animation: child.props.animation !== undefined ? child.props.animation : animation,
        id: child.props.id || "k-panelbar-item-default-" + privateKey,
        uniquePrivateKey: privateKey,
        parentUniquePrivateKey: parentPrivateKey,
        parentExpanded: parentExpanded,
        root: root,
        expanded: (state.expanded || []).indexOf(privateKey) > -1 && parentExpanded,
        focused: state.focused === privateKey && state.wrapperFocused,
        selected: state.selected === privateKey,
        children: nestedChildren,
        onSelect: handleSelect
      }));
    } else {
      return React.createElement("div", {
        className: "k-content"
      }, child);
    }
  });
};
/**
 * @hidden
 */

export var getInitialState = function getInitialState(props, expandMode, result, _, parentExpanded, parentPrivateKey) {
  if (result === void 0) {
    result = {
      expanded: props.expanded || [],
      selected: props.selected || '',
      focused: props.focused || '.0',
      wrapperFocused: false
    };
  }

  if (_ === void 0) {
    _ = true;
  }

  if (parentExpanded === void 0) {
    parentExpanded = true;
  }

  if (parentPrivateKey === void 0) {
    parentPrivateKey = [];
  }

  React.Children.map(props.children, function (child, idx) {
    if (child && child.type === PanelBarItem) {
      var privateKey = parentPrivateKey.length ? parentPrivateKey[parentPrivateKey.length - 1] + ("." + idx) : "." + idx;

      if (!child.props.disabled && parentExpanded) {
        if (child.props.selected) {
          result.selected = privateKey;
        }

        if (child.props.focused) {
          result.focused = privateKey;
        }

        if (child.props.expanded) {
          if (expandMode === 'multiple') {
            result.expanded.push(privateKey);
          } else if (expandMode === 'single') {
            result.expanded = [privateKey];
          }
        }

        if (child.props.children) {
          result = getInitialState(child.props, expandMode, result, false, !!child.props.expanded, parentPrivateKey.concat([privateKey]));
        }
      }
    }
  });
  return result;
};
/**
 * @hidden
 */

export function flatVisibleItems(data, flattedItems, _) {
  if (flattedItems === void 0) {
    flattedItems = [];
  }

  if (_ === void 0) {
    _ = null;
  }

  (data || []).forEach(function (item) {
    if (!item.disabled) {
      flattedItems.push(item);

      if (item.expanded && item.children) {
        flatVisibleItems(item.children, flattedItems);
      }
    }
  });
  return flattedItems;
}
/**
 * @hidden
 */

export var isPresent = function isPresent(value) {
  return value !== null && value !== undefined;
};
/**
 * Represents the PanelBarUtils functions.
 */

export var PanelBarUtils;

(function (PanelBarUtils) {
  /**
   * Maps a collection of PanelBarItemProps to PanelBarItem components
   * ([see example]({% slug customization_panelbar %})).
   * Contained in the `PanelBarUtils` object.
   *
   * @param items - A collection of PanelBarItemProps.
   * @return {PanelBarItem[]} Returns an array of PanelBarItem components.
   */
  function mapItemsToComponents(items) {
    return items.map(function (item, idx) {
      var children;

      if (item.content) {
        children = item.content;
      }

      if (item.children) {
        children = mapItemsToComponents(item.children);
      }

      return React.createElement(PanelBarItem, __assign({}, item, {
        children: children,
        key: item.id || idx
      }));
    });
  }

  PanelBarUtils.mapItemsToComponents = mapItemsToComponents;
})(PanelBarUtils || (PanelBarUtils = {}));
/**
 * @hidden
 */


export var isArrayEqual = function isArrayEqual(firstArray, secondArray) {
  if (firstArray.length !== secondArray.length) {
    return false;
  }

  return firstArray.every(function (ex, i) {
    return ex === secondArray[i];
  });
};